import { render } from "./UnrecoverableError.vue?vue&type=template&id=3331f0c6&scoped=true&ts=true"
import script from "./UnrecoverableError.vue?vue&type=script&lang=ts"
export * from "./UnrecoverableError.vue?vue&type=script&lang=ts"

import "./UnrecoverableError.vue?vue&type=style&index=0&id=3331f0c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3331f0c6"]])

export default __exports__